import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $state, $q, $stateParams, SearchService, ViewModelService, ModalService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.searchRequest = {
            searchParam: '',
            previousSearchParam: ''
        };

        $scope.searchResults = {
            accounts: [],
            policies: []
        };

        $scope.accountInfos = [];
        $scope.policyInfos = [];

        $scope.searchCompleted = false;
        this.search($stateParams.searchParam);
    };

    ctrl.search = function (searchParam) {
        if (searchParam != undefined && searchParam.length >= 5) {
            $scope.searchParamLengthValid = true;
            $scope.searchRequest.previousSearchParam = $scope.searchRequest.searchParam;
            $scope.searchRequest.searchParam = searchParam;
            var searchResults = SearchService.search($scope.searchRequest);
            $scope.searchResultsPromise = searchResults;

            $q.when(searchResults, function (searchResult) {
                $scope.searchResults.accounts = searchResult.accounts;
                $scope.searchResults.policies = searchResult.policies;
                populateAccountResults();
                populatePolicyResults();
                $scope.searchCompleted = true;
            }, function (error) {
                if (error.baseError.data.error) {
                    if (error.baseError.data.error.data.appErrorCode !== 609) {
                        ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                    }
                } else {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                }
                $scope.searchCompleted = true;
            });
        } else {
            $scope.searchRequest.searchParam = searchParam;
            $scope.searchResultsPromise = [];
            $scope.searchCompleted = true;
            $scope.searchParamLengthValid = false;
        }
    };

    var populateAccountResults = function populateAccountResults() {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.accountInfos.length > 0) {
                $scope.accountInfos.pop();
            }

            $scope.searchResults.accounts.forEach(function (account) {
                if (account !== null) {
                    var accountInfo = {
                        accountNumber: '',
                        accountName: '',
                        FEINId: '',
                        SSNId: '',
                        RISKId: '',
                        primaryAddress: '',
                        producerCodes: [],
                        policySummaries: []
                    };

                    accountInfo.accountNumber = account.accountNumber;
                    accountInfo.accountName = account.accountHolder;
                    accountInfo.FEINId = account.msfFeinId_EXT;
                    accountInfo.SSNId = account.msfSSNId_EXT;
                    accountInfo.RISKId = account.msfRiskId_EXT;
                    accountInfo.primaryAddress = account.accountHolderAddress;
                    $scope.accountInfos.push(accountInfo);
                }
            });
        }
        return $scope.accountInfos;
    };

    var populatePolicyResults = function populatePolicyResults() {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.policyInfos.length > 0) {
                $scope.policyInfos.pop();
            }

            $scope.searchResults.policies.forEach(function (policy) {
                if (angular.isDefined(policy.policyNumber)) {
                    var policyInfo = {
                        account: {
                            accountHolder: {
                                contactName: '',
                                firstName: '',
                                lastName: ''
                            }
                        },
                        linesOfBusiness: '',
                        policyNumber: '',
                        accountNumber: '',
                        accountName: '',
                        primaryAddress: '',
                        FEINID: '',
                        producerCode: ''
                    };

                    policyInfo.policyNumber = policy.policyNumber;
                    policyInfo.accountNumber = policy.accountNumber;
                    policyInfo.FEINID = policy.msfFeinId_EXT;
                    if (policy.accountHolder.subtype === 'Company') {
                        policyInfo.account.accountName = policy.accountHolder.contactName;
                    } else if (policy.accountHolder.subtype === 'Person') {
                        policyInfo.account.accountName = policy.accountHolder.firstName + ' ' + policy.accountHolder.lastName;
                    }
                    policyInfo.primaryAddress = policy.accountHolder.primaryAddress;
                    $scope.policyInfos.push(policyInfo);
                }
            });
        }
        return $scope.policyInfos;
    };
    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$q', '$stateParams', 'SearchService', 'ViewModelService', 'ModalService'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/SearchCtrl.js
// module id = 1687
// module chunks = 0